import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { persistActiveProductView } from "../auth/viewAccess";

/** Keeps sidebar view label in sync when navigating between product areas. */
export function ActiveViewPersistence() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/staff")) {
      persistActiveProductView("staff");
      return;
    }
    if (pathname.startsWith("/login") || pathname.startsWith("/account")) return;
    persistActiveProductView("management");
  }, [pathname]);

  return null;
}
